import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {TextLink} from '@/common/components/TextLink';
import styles from './AppFooter.css';

export const AppFooter: FC = () => {
	const t = useLocalizer();

	const currentYear = new Date().getFullYear().toString();

	return (
		<footer className={styles.root}>
			<p className={styles.info}>{t('copyright', {domain: DOMAIN_NAME, currentYear})}</p>
			<p>
				<TextLink className={styles.link} href='/agreement'>
					{t('termsAgreement')}
				</TextLink>
				<TextLink className={styles.link} href='/privacypolicy'>
					{t('privacyAgreement')}
				</TextLink>
				<TextLink className={styles.link} href={`/feedback?skin=feedback&lang=${t.language}`}>
					{t('sendGeneralFeedback')}
				</TextLink>
				<TextLink className={styles.link} href={`/feedback?skin=feedback&lang=${t.language}&mode=ads`}>
					{t('sendAdQuestion')}
				</TextLink>
			</p>
		</footer>
	);
};

AppFooter.displayName = 'AppFooter';
